import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/vercel/path0/website/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Counters";
const frontMatter = {};
import ReactiveState from '@/examples/reactive-state';
import DelayedTick from '@/examples/tick';
import FizzBuzz from '@/examples/fizz-buzz';
export function useTOC(props) {
  return [{
    value: "Configurable interval",
    id: "configurable-interval",
    depth: 2
  }, {
    value: "Delayed tick",
    id: "delayed-tick",
    depth: 2
  }, {
    value: "Fizz Buzz",
    id: "fizz-buzz",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    h2: "h2",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<ReactiveState />{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<DelayedTick />{"\n"}<_components.h2 id={toc[2].id}>{toc[2].value}</_components.h2>{"\n"}<FizzBuzz /></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/examples/counters',
  {"filePath":"src/pages/examples/counters.mdx","timestamp":1764791534000,pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)